
import React, {type ChangeEvent, type ReactHTMLElement, useState} from 'react'
import s from './HW11.module.css'
import s2 from '../../s1-main/App.module.css'
import { restoreState } from '../hw06/localStorage/localStorage'
import SuperRange from './common/c7-SuperRange/SuperRange'


/*
* 1 - передать значения в оба слайдера
* 2 - дописать типы и логику функции change
* 3 - сделать стили в соответствии с дизайном
*/




function HW11() {
    // for autotests // не менять // можно подсунуть в локалСторэдж нужные числа, чтоб увидеть как они отображаются
    const [value1, setValue1] = useState(restoreState<number>('hw11-value1', 0))
    const [value2, setValue2] = useState(restoreState<number>('hw11-value2', 100))

    const change = (event: Event, value: number | number[]) => {
        if (Array.isArray(value)) {
            setValue1(value[0]);
            setValue2(value[1]);
        } else {
            setValue1(value);
        }
    }

    return (
        <div id={'hw11'}>
            <div className={s2.hwTitle}>Homework #11</div>

            <div className={s2.hw}>
                <div className={s.container}>
                    <div className={s.wrapper}>
                        <span id={'hw11-value'} className={s.number}>{value1}</span>
                        <SuperRange
                            id={'hw11-single-slider'}
                            // сделать так чтоб value1 изменялось // пишет студент
                            value={value1}
                            onChange={change}
                        />
                    </div>
                    <div className={s.wrapper}>
                        <span id={'hw11-value-1'} className={s.number}>{value1}</span>
                        <SuperRange
                            id={'hw11-double-slider'}
                            // сделать так чтоб value1/2 изменялось // пишет студент
                            value={[value1, value2]}
                            onChange={change}

                        />
                        <span id={'hw11-value-2'} className={s.number}>{value2}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HW11






//_________________________________________________________________________

/*import React, { useState } from 'react';
import s from './HW11.module.css'; // Стили для текущего модуля
import s2 from '../../s1-main/App.module.css'; // Общие стили приложения
import { restoreState } from '../hw06/localStorage/localStorage'; // Локальное сохранение (пример)
import SuperRange from './common/c7-SuperRange/SuperRange'; // Компонент слайдера

function HW11() {
    // Инициализация значений слайдеров
    const [value1, setValue1] = useState(restoreState<number>('hw11-value1', 0));
    const [value2, setValue2] = useState(restoreState<number>('hw11-value2', 100));

    // Обработчик изменения для одного или двух слайдеров
    const change = (event: Event, value: number | number[]) => {
        if (Array.isArray(value)) {
            // Управление двойным слайдером
            setValue1(value[0]);
            setValue2(value[1]);
        } else {
            // Управление одиночным слайдером
            setValue1(value);
        }
    };

    return (
        <div id="hw11">
            <div className={s2.hwTitle}>Homework #11</div>

            <div className={s2.hw}>
                <div className={s.container}>
                    {/!* Блок с одиночным слайдером (SuperRange) *!/}
                    <div className={s.wrapper}>
                        <span id="hw11-value" className={s.number}>{value1}</span>
                        <SuperRange
                            id="hw11-single-slider"
                            value={value1}
                            onChange={change} // Передача обработчика изменений
                        />
                    </div>

                    {/!* Блок с двойным слайдером *!/}
                    <div className={s.wrapper}>
                        <span id="hw11-value-1" className={s.number}>{value1}</span>
                        <SuperRange
                            id="hw11-double-slider"
                            value={[value1, value2]} // Массив значений для двойного слайдера
                            onChange={change} // Передача обработчика
                        />
                        <span id="hw11-value-2" className={s.number}>{value2}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HW11;*/





